// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"277":"573488d0","311":"b19ff7e5","726":"0ffd90ff","727":"b23d8cc5","787":"27d909d0"}[chunkId] + ".chunk.js";
};